var map = {
	"./AppIcon-OceanAlert.appiconset/iTunesArtwork.png": 7209,
	"./AppIcon-OceanAlert.appiconset/whale-icon-20@1x.png": 9100,
	"./AppIcon-OceanAlert.appiconset/whale-icon-20@2x.png": 3637,
	"./AppIcon-OceanAlert.appiconset/whale-icon-20@3x.png": 7804,
	"./AppIcon-OceanAlert.appiconset/whale-icon-29@1x.png": 6129,
	"./AppIcon-OceanAlert.appiconset/whale-icon-29@2x.png": 222,
	"./AppIcon-OceanAlert.appiconset/whale-icon-29@3x.png": 9297,
	"./AppIcon-OceanAlert.appiconset/whale-icon-40@1x.png": 5962,
	"./AppIcon-OceanAlert.appiconset/whale-icon-40@2x.png": 6700,
	"./AppIcon-OceanAlert.appiconset/whale-icon-40@3x.png": 2006,
	"./AppIcon-OceanAlert.appiconset/whale-icon-60@2x.png": 8330,
	"./AppIcon-OceanAlert.appiconset/whale-icon-60@3x.png": 101,
	"./AppIcon-OceanAlert.appiconset/whale-icon-76@1x.png": 4032,
	"./AppIcon-OceanAlert.appiconset/whale-icon-76@2x.png": 103,
	"./AppIcon-OceanAlert.appiconset/whale-icon-83.5@2x.png": 6176,
	"./AppIcon-OceanAlert.appiconset/whale-icon-iPad-29@2x.png": 748,
	"./AppIcon-OceanAlert.appiconset/whale-icon-iPad-40@2x.png": 3937,
	"./AppIcon-Sharktivity.appiconset/Sharktivity-40@3x.png": 6710,
	"./AppIcon-Sharktivity.appiconset/Sharktivity-60@2x.png": 2262,
	"./AppIcon-Sharktivity.appiconset/Sharktivity-60@3x.png": 6954,
	"./AppIcon-Sharktivity.appiconset/Sharktivity-76@1x.png": 7930,
	"./AppIcon-Sharktivity.appiconset/Sharktivity-76@2x.png": 534,
	"./AppIcon-Sharktivity.appiconset/Sharktivity-83.5@2x.png": 9362,
	"./AppIcon-Untethered.appiconset/untethered.png": 1134,
	"./AppIcon-Untethered.appiconset/whale-icon-20@1x.png": 7883,
	"./AppIcon-Untethered.appiconset/whale-icon-20@2x.png": 5815,
	"./AppIcon-Untethered.appiconset/whale-icon-20@3x.png": 6796,
	"./AppIcon-Untethered.appiconset/whale-icon-29@1x.png": 1347,
	"./AppIcon-Untethered.appiconset/whale-icon-29@2x.png": 192,
	"./AppIcon-Untethered.appiconset/whale-icon-29@3x.png": 7555,
	"./AppIcon-Untethered.appiconset/whale-icon-40@1x.png": 7252,
	"./AppIcon-Untethered.appiconset/whale-icon-40@2x.png": 7230,
	"./AppIcon-Untethered.appiconset/whale-icon-40@3x.png": 1227,
	"./AppIcon-Untethered.appiconset/whale-icon-60@2x.png": 2559,
	"./AppIcon-Untethered.appiconset/whale-icon-60@3x.png": 9311,
	"./AppIcon-Untethered.appiconset/whale-icon-76@1x.png": 4765,
	"./AppIcon-Untethered.appiconset/whale-icon-76@2x.png": 7407,
	"./AppIcon-Untethered.appiconset/whale-icon-83.5@2x.png": 104,
	"./AppIcon-Untethered.appiconset/whale-icon-iPad-29@2x.png": 2289,
	"./AppIcon-Untethered.appiconset/whale-icon-iPad-40@2x.png": 4974,
	"./AppIcon-WhaleAlert.appiconset/iTunesArtwork.png": 5326,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-20@1x.png": 9939,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-20@2x.png": 4323,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-20@3x.png": 3101,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-29@1x.png": 4701,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-29@2x.png": 1401,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-29@3x.png": 3775,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-40@1x.png": 2355,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-40@2x.png": 8095,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-40@3x.png": 4290,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-60@2x.png": 3076,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-60@3x.png": 8718,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-76@1x.png": 4569,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-76@2x.png": 8898,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-83.5@2x.png": 6436,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-iPad-29@2x.png": 4879,
	"./AppIcon-WhaleAlert.appiconset/whale-icon-iPad-40@2x.png": 1165,
	"./DemoDot.imageset/DemoDot@1x.png": 5361,
	"./DemoDot.imageset/DemoDot@2x.png": 2738,
	"./DemoDot.imageset/DemoDot@3x.png": 5709,
	"./UT-launch-logo.imageset/UT-launch-logo@2x.png": 832,
	"./WA-launch-TrackUser.imageset/WA-launch-TrackUser@2x.png": 3453,
	"./WA-launch-button.imageset/WA-launch-button@2x.png": 8803,
	"./WA-launch-iO.imageset/WA-launch-iO@2x.png": 8979,
	"./WA-launch-logo.imageset/WA-launch-logo@2x.png": 9993,
	"./WA-launch-noaa.imageset/WA-launch-noaa@2x.png": 9918,
	"./binoculars.imageset/binoculars@1x.png": 1120,
	"./binoculars.imageset/binoculars@2x.png": 5793,
	"./blue-blue-lbl.imageset/blue-blue-lbl.png": 243,
	"./blue-purple-lbl.imageset/blue-purple-lbl.png": 6191,
	"./blue.imageset/blue.png": 8707,
	"./btn-QuickInfo.imageset/QuickInfo@1x.png": 8923,
	"./btn-QuickInfo.imageset/QuickInfo@2x.png": 761,
	"./buoy-green-large.imageset/buoy-green-large@2x.png": 3008,
	"./buoy-green-small.imageset/buoy-green-small.png": 3521,
	"./buoy-grey-large.imageset/buoy-grey-large@2x.png": 5729,
	"./buoy-grey-small.imageset/buoy-grey-small.png": 8290,
	"./buoy-yellow-large.imageset/buoy-yellow-large@2x.png": 4590,
	"./buoy-yellow-small.imageset/buoy-yellow-small.png": 8456,
	"./caution-purple.imageset/caution-purple.png": 4721,
	"./caution.imageset/caution.png": 9762,
	"./coyote-purple.imageset/coyote-purple.png": 5426,
	"./coyote.imageset/coyote.png": 6600,
	"./crab-trap-green.imageset/crab-trap-green.png": 5799,
	"./crab-trap-purple.imageset/crab-trap-purple.png": 2433,
	"./crab-trap-red.imageset/crab-trap-red.png": 1475,
	"./crab-trap.imageset/crab-trap.png": 4358,
	"./crown-of-thorns-purple.imageset/crown-of-thorns-purple.png": 1183,
	"./crown-of-thorns.imageset/crown-of-thorns.png": 360,
	"./crustacean-purple.imageset/crustacean-purple.png": 1798,
	"./crustacean.imageset/crustacean.png": 5173,
	"./diver-flag.imageset/diver-flag.png": 9831,
	"./dolphin-blue.imageset/dolphin-blue.png": 3652,
	"./dolphin-purple.imageset/dolphin-purple.png": 9123,
	"./dolphin.imageset/dolphin.png": 4424,
	"./dot-black.imageset/dot-black-old.png": 7523,
	"./dot-black.imageset/dot-black-oldblk.png": 2389,
	"./dot-black.imageset/dot-black.png": 125,
	"./dot-blue.imageset/dot-blue.png": 6992,
	"./dot-cyan.imageset/dot-cyan.png": 1562,
	"./dot-gray.imageset/dot-gray1x.png": 8092,
	"./dot-gray.imageset/dot-gray2x.png": 9791,
	"./dot-gray.imageset/dot-gray3x.png": 1986,
	"./dot-green.imageset/dot-green1x.png": 4245,
	"./dot-green.imageset/dot-green2x.png": 8575,
	"./dot-green.imageset/dot-green3x.png": 3721,
	"./dot-grey.imageset/dot-grey1x.png": 5667,
	"./dot-grey.imageset/dot-grey2x.png": 4933,
	"./dot-grey.imageset/dot-grey3x.png": 1036,
	"./dot-orange.imageset/dot-orange.png": 3957,
	"./dot-purple.imageset/dot-purple.png": 4309,
	"./dot-red.imageset/dot-red1x.png": 850,
	"./dot-red.imageset/dot-red2x.png": 829,
	"./dot-red.imageset/dot-red3x.png": 168,
	"./dot-yellow.imageset/dot-yellow.png": 2077,
	"./dot-yellow.imageset/dot-yellow1x.png": 7601,
	"./dot-yellow.imageset/dot-yellow2x.png": 4067,
	"./dot-yellow.imageset/dot-yellow3x.png": 454,
	"./fin-blue-lbl.imageset/fin-blue-lbl.png": 5590,
	"./fin-purple-lbl.imageset/fin-purple-lbl.png": 234,
	"./fin.imageset/fin.png": 6831,
	"./fish-purple.imageset/fish-purple.png": 4076,
	"./fish.imageset/fish.png": 7463,
	"./forms-toggle-OFF.imageset/forms-toggle-off@2x.png": 7546,
	"./forms-toggle-ON.imageset/forms-toggle-on@2x.png": 5552,
	"./ghost-gear-purple.imageset/ghost-gear-purple.png": 6988,
	"./glider-purple.imageset/glider-purple.png": 4707,
	"./glider.imageset/glider.png": 9695,
	"./gray-blue-lbl.imageset/gray-blue-lbl.png": 7405,
	"./gray-purple-lbl.imageset/gray-purple-lbl.png": 8245,
	"./gray.imageset/gray.png": 9995,
	"./humpback-blue-lbl.imageset/humpback-blue-lbl.png": 1759,
	"./humpback-purple-lbl.imageset/humpback-purple-lbl.png": 987,
	"./humpback.imageset/humpback.png": 8252,
	"./kelp-purple.imageset/kelp-purple.png": 4982,
	"./kelp.imageset/kelp.png": 9799,
	"./legends-info.imageset/info@2x.png": 8211,
	"./lionfish-purple.imageset/lionfish-purple.png": 5412,
	"./lionfish.imageset/lionfish.png": 9329,
	"./location-inverted.imageset/location-inverted@1x.png": 6484,
	"./location-inverted.imageset/location-inverted@2x.png": 2573,
	"./location.imageset/location@1x.png": 9349,
	"./location.imageset/location@2x.png": 172,
	"./logo-BOEM.imageset/logo-BOEM@2x.png": 9679,
	"./logo-IFAW.imageset/logo-IFAW@2x.png": 9576,
	"./logo-NMS-2023.imageset/logo-NMS-2023@2x.png": 9091,
	"./logo-NMS.imageset/logo-NMS@2x.png": 6357,
	"./logo-NOAA.imageset/logo-NOAA@2x.png": 3749,
	"./manatee-blue.imageset/manatee-blue.png": 9806,
	"./manatee-purple.imageset/manatee-purple.png": 76,
	"./manatee.imageset/manatee.png": 4715,
	"./marfor.imageset/marfor.png": 3967,
	"./monarch-purple.imageset/monarch-purple.png": 7813,
	"./monarch.imageset/monarch.png": 8457,
	"./orca-blue-lbl.imageset/orca-blue-lbl.png": 305,
	"./orca-purple-lbl.imageset/orca-purple-lbl.png": 3273,
	"./orca.imageset/orca.png": 8362,
	"./orcanetwork.imageset/orcanetwork.png": 1927,
	"./port-large.imageset/port-large@2x.png": 5063,
	"./port-small.imageset/port-small@2x.png": 3655,
	"./sea-turtle-purple.imageset/sea-turtle-purple.png": 319,
	"./sea-turtle.imageset/sea-turtle.png": 6892,
	"./seabird-purple.imageset/seabird-purple.png": 8130,
	"./seabird.imageset/seabird.png": 2543,
	"./seal-blue.imageset/seal-blue.png": 1420,
	"./seal-purple.imageset/seal-purple.png": 6502,
	"./seal.imageset/seal.png": 3615,
	"./sealion-blue.imageset/sealion-blue.png": 5749,
	"./sealion-purple.imageset/sealion-purple.png": 9718,
	"./sealion.imageset/sealion.png": 7586,
	"./shell-purple.imageset/shell-purple.png": 27,
	"./shell.imageset/shell.png": 7659,
	"./sperm-blue-lbl.imageset/sperm-blue-lbl.png": 9788,
	"./sperm-purple-lbl.imageset/sperm-purple-lbl.png": 9721,
	"./sperm.imageset/sperm.png": 4498,
	"./sr-orca-red.imageset/sr-orca-red.png": 6521,
	"./sr-orca-yellow.imageset/sr-orca-yellow.png": 1058,
	"./tides.imageset/tides.png": 6907,
	"./trash-purple.imageset/trash-purple.png": 7191,
	"./trash.imageset/trash.png": 8131,
	"./urchin-purple.imageset/urchin-purple.png": 1132,
	"./urchin.imageset/urchin.png": 703,
	"./whale-icon-blue.imageset/whale-icon-green@2x.png": 2246,
	"./whale-icon-gray.imageset/whale-icon-gray.png": 5226,
	"./whale-icon-green.imageset/whale-icon-green.png": 5212,
	"./whale-icon-green.imageset/whale-icon-green@2x.png": 7520,
	"./whale-icon-purple.imageset/whale-icon-purple.png": 6684,
	"./whale-icon-yellow.imageset/whale-icon-yellow.png": 1561,
	"./whale-icon-yellow.imageset/whale-icon-yellow@2x.png": 6295,
	"./whale-icon.imageset/whale-icon-green@2x.png": 2357,
	"./whale-watch-boat-purple.imageset/whale-watch-boat-purple.png": 6101,
	"./whale-watch-boat.imageset/whale-watch-boat.png": 8952,
	"./whaletrail.imageset/whaletrail.png": 4726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;